export enum Parentesco {
  HIJO = 'HIJO',
  HIJA = 'HIJA',
}

/**
 * Función para convertir un string en un valor del enum.
 */
export default function asignarParentesco(tsString: string): Parentesco | undefined {
  if (Object.values(Parentesco).includes(tsString as Parentesco)) {
    return tsString as Parentesco;
  }
  return null;
}
